<template>
  <CustomSelect
    class="w-100"
    inputId="volumeDiscountTypePicker"
    inputLabel="مورد تخفیف"
    :customOptions="volumeDiscountTypes"
    :value="value"
    @input="$emit('input', $event)"
  >
  </CustomSelect>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number, null],
      default: null,
    },
  },
  model: {
    prop: "value",
    event: "input",
  },
  data() {
    return {
      volumeDiscountTypes: [
        // {
        //   value: 0,
        //   text: "گروه‌بندی های دروس",
        // },
        {
          value: 1,
          text: "درس",
        },
        {
          value: 2,
          text: "دوره",
        },
      ],
    };
  },
  components: {
    CustomSelect,
  },
};
import CustomSelect from "@/views/components/Utils/CustomSelect.vue";
</script>
